(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const country = root.querySelector('[data-sh-country]');
    const region = root.querySelector('[data-sh-region]');
    const panels = [...root.querySelectorAll('[data-sh-panel]')];
    function render() {
      const key = country.value === 'ES' ? region.value : country.value;
      root.querySelector('[data-sh-region-field]').hidden = country.value !== 'ES';
      panels.forEach(panel => { panel.hidden = panel.dataset.shPanel !== key; });
    }
    country.addEventListener('change', render);
    region.addEventListener('change', render);
    root.querySelector('[data-sh-selectors]').hidden = false;
    render();
  }
  function scan(scope) {
    scope.querySelectorAll('[data-shuu-shipping-guide]').forEach(initialize);
  }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-shuu-shipping-guide] [data-sh-country]').forEach(select => select.dispatchEvent(new Event('change')));
  });
})();
